import { API_VERSION_ONE, handleAPI } from "../../../../../itrust_common/utils/apiUtils";

export function visionInsuranceProcedureMappingsLoad(filters = {}) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/procedure_mappings`;
  const method = 'GET'
  return {
    type: 'VISION_INSURANCE_PROCEDURE_MAPPINGS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function visionInsuranceProcedureMappingsPrefilledLoad(filters={}){
   const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/benefit_mappers`;
  const method = 'GET'
  return {
    type: 'VISION_INSURANCE_PROCEDURE_MAPPINGS_PREFILLED_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function visionInsuranceProcedureMappingCreate(data) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/benefit_mappers`;
  const method = 'POST'
  return {
    type: 'VISION_INSURANCE_PROCEDURE_MAPPING_CREATE',
    payload: handleAPI(url, data, method)
  };
}
export function syncMemberBenefitLoad(filters={}) {
    const { log_id, ...params } = filters;
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${log_id}/sync`;
  const method = 'GET';
  return {
    type: 'SYNC_MEMBER_BENEFIT_LOAD',
    payload: handleAPI(url, filters, method)
  };
}
